import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=4e8905a0&scoped=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"
import style0 from "./MaterialSelect.vue?vue&type=style&index=0&id=4e8905a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8905a0",
  null
  
)

export default component.exports